<template>
<div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
        Notes
        <span
            v-if="can_update"
            @click="startEditing()"
            v-tooltip.bottom="'Add Note'"
            class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none"
            data-test="addNoteButton" >
            <i class="far fa-plus-circle text-base" />
        </span>
    </div>
    <ul class="list-group list-group-flush">    
        <li v-if="state === 'editing'" class="list-group-item">
            <vue-editor 
                :editor-toolbar="config.editor.toolbar"
                v-model="data.body"
                data-test="noteBody"
            />

            <div class="form-group text-right mt-3 mb-0">
                <button type="button" class="btn btn-ghost-secondary" @click="stopEditing">Cancel</button>
                <button type="button" class="btn btn-primary" @click="saveNote" data-test="saveNoteButton">Save</button>   
            </div>
        </li>

        <notes-item
            v-for="note in all_notes"
            :key="note.id"
            :note="note"                     
            @note-updated="updateNote($event)"
            @note-deleted="deleteNote($event)">
        </notes-item>
        <div v-if="all_notes.length == 0 && state == 'default'" class="text-center text-lg text-gray-500 p-3">
            No notes
        </div>
    </ul>   
</div>
</template>


<script>
    import { mapState } from 'vuex';
    import NotesItem from './NotesItem';

    export default {
        components: {
            NotesItem,
        },

        props: ['noteable_id', 'noteable_type', 'notes', 'can_update'], 

        data() {
            return {
                state: 'default',
                data: {
                    body: '',
                    noteable_id: this.noteable_id,
                    noteable_type: 'App\\' + this.noteable_type,
                },            
                all_notes: this.notes,
            }
        },

        methods: {
            startEditing() {
                this.state = 'editing';
            },

            stopEditing() {
                this.state = 'default';
                this.data.body = '';
            },            

            saveNote() {
                axios.post('/api/notes', this.data).then(({data}) => {
                    this.all_notes.push(data);
                    this.stopEditing();

                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: 'Note saved',
                    });                        
                })
            },

            updateNote($event) {
                axios.put(`/api/notes/${$event.id}`, $event).then(({data}) => {
                    this.all_notes[this.noteIndex($event.id)].body = data.body;
                })
            },

            deleteNote($event) {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this note.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete note',
                      cancelButtonText: 'Keep note',
                      animation: false,
                    }).then((result) => {
                        if (result.value) {
                            axios.delete(`/api/notes/${$event.id}`, $event).then(() => {
                                this.all_notes.splice(this.noteIndex($event.id), 1);
                            })
                        }
                    }
                );
            },

            noteIndex(noteId) {
                return this.all_notes.findIndex((element) => {
                    return element.id === noteId;
                });
            }             
        },   

        computed: mapState(['config'])     
    }
</script>